import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import { grey } from '@mui/material/colors';
import { Box } from '@mui/material';

const useStyles = makeStyles(theme => ({
  triangle: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderColor: `transparent transparent ${grey[400]} transparent`,
    margin: '10px auto',

    '&:after': {
      content: '""',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderColor: `transparent transparent ${theme.palette.custom.white} transparent`,
      transform: 'translate(-50%, 16%)',
    },
  },
  top: {
    transform: 'rotate(0deg)',
  },
  right: {
    transform: 'rotate(90deg)',
  },
  bottom: {
    transform: 'rotate(180deg)',

    '&:after': {
      borderBottomWidth: '35px !important',
    },
  },
  left: {
    transform: 'rotate(270deg)',

    '&:after': {
      borderBottomWidth: '35px !important',
    },
  },
  small: {
    borderWidth: '0 12px 20.8px 12px',

    '&:after': {
      borderWidth: '0 10px 17px 10px',
    },
  },
  large: {
    borderWidth: '0 25px 43.3px 25px',

    '&:after': {
      borderWidth: '0 21px 36px 21px',
    },
  },
}));

const Triangle = ({ variant, size, className }) => {
  const classes = useStyles();

  return <Box className={clsx([classes.triangle, classes[size], classes[variant], className])} />;
};

Triangle.defaultProps = {
  className: '',
  variant: 'top',
  size: 'large',
};

Triangle.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  size: PropTypes.oneOf(['small', 'large']),
};

export default Triangle;
